<template>
  <div>
    <section class="learning-intro">
      <div>
        <span class="learning-eyebrow">
          <feather-icon icon="BookOpenIcon" size="14" />
          Tableau d’enseignement
        </span>
        <h1>Bonjour, retrouvez vos groupes</h1>
        <p>Gérez vos classes, consultez vos étudiants et partagez vos nouveaux supports depuis un seul espace.</p>
      </div>
      <div
        v-if="!loading && groups.length"
        class="learning-summary"
      >
        <div class="learning-summary-item">
          <strong>{{ groups.length }}</strong>
          <span>Groupe(s)</span>
        </div>
        <div class="learning-summary-item">
          <strong>{{ totalStudents }}</strong>
          <span>Étudiant(s)</span>
        </div>
        <div class="learning-summary-item">
          <strong>{{ totalMaterials }}</strong>
          <span>Support(s)</span>
        </div>
      </div>
    </section>

    <div
      v-if="loading"
      class="ma-loading"
    >
      Chargement…
    </div>

    <div
      v-else-if="!groups.length"
      class="ma-card ma-empty"
    >
      <div class="ma-empty-ico">
        <feather-icon
          icon="LayersIcon"
          size="30"
        />
      </div>
      <h4>Aucun groupe pour le moment</h4>
      <p>Les groupes sont créés par l'administration et vous sont affectés. Ils apparaîtront ici.</p>
    </div>

    <div
      v-else
      class="learning-groups-grid"
    >
      <article
        v-for="g in groups"
        :key="g._id"
        class="learning-group-card"
        @click="open(g)"
      >
        <div
          class="learning-group-cover"
          style="background: linear-gradient(135deg, #19C8B6 0%, #0C8478 100%);"
        >
          <span class="learning-group-icon">
            <feather-icon icon="BookOpenIcon" size="20" />
          </span>
          <span class="learning-group-code">{{ g.code }}</span>
        </div>
        <div class="learning-group-body">
          <h2>{{ g.name }}</h2>
          <div class="learning-group-tags">
            <span
              v-if="g.level"
              class="ma-badge level"
            >{{ g.level }}</span>
            <span
              v-if="g.subject"
              class="ma-badge subject"
            >{{ g.subject }}</span>
          </div>
          <div class="learning-group-footer">
            <span>
              <feather-icon
                icon="UsersIcon"
                size="14"
              />
              {{ g.memberCount || 0 }} étudiant(s)
            </span>
            <span class="learning-open">
              Ouvrir
              <feather-icon icon="ArrowRightIcon" size="14" />
            </span>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import axios from '@axios'

export default {
  name: 'MindsTutorGroups',
  data() {
    return { groups: [], loading: true }
  },
  computed: {
    totalStudents() {
      return this.groups.reduce((total, group) => total + (group.memberCount || 0), 0)
    },
    totalMaterials() {
      return this.groups.reduce((total, group) => total + (group.materialCount || 0), 0)
    },
  },
  mounted() { this.fetch() },
  methods: {
    async fetch() {
      this.loading = true
      try {
        const res = await axios.get('/ma/tutor/groups')
        this.groups = res.data.groups || []
      } catch (e) {
        this.groups = []
      } finally {
        this.loading = false
      }
    },
    open(g) {
      this.$router.push({ name: 'minds-tutor-group', params: { id: g._id } })
    },
  },
}
</script>

<style src="../admin/minds.css"></style>
<style src="../learning.css"></style>
